import { FC } from "react";
import { Redirect, Route, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { RootState } from "store/types";
import { UserData } from "store/reducers/session/types";
import { AppRoute } from "routes";
import { errorAlert } from "utils/alerts";
import { NOT_LOGIN_REPORT_ERROR } from "consts";

export interface PrivateRouteProps extends RouteComponentProps, AppRoute {
  isAuthenticated: boolean;
  user: UserData | null;
}

let hasShownReportError = false;

const PrivateRoute: FC<PrivateRouteProps> = ({ isAuthenticated = false, user, allowedRoles, history, ...rest }: PrivateRouteProps) => {
  if (!isAuthenticated) {
    if (!hasShownReportError && window.location.pathname.includes('report') && !window.location.pathname.includes('automated-reports')) {
      hasShownReportError = true;
      errorAlert(NOT_LOGIN_REPORT_ERROR);
    }
    return <Redirect to="/login" />;
  }

  if (user && allowedRoles && allowedRoles.length && !allowedRoles.includes(user.role)) {
    return <Redirect to="/" />;
  }

  // @ts-ignore
  return <Route history={history} {...rest} />;
};

const mapStateToProps = (state: RootState) => ({
  isAuthenticated: state.session.isAuthenticated,
  user: state.session.user,
});

export default connect(mapStateToProps, null)(PrivateRoute);
